
import React from "react";
import classnames from "classnames";
import { AvForm, AvField, AvGroup, AvInput } from 'availity-reactstrap-validation';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
import connect from 'redux-connect-decorator';
import { changePassword } from '../../../../actions/authActions';
import { Redirect } from 'react-router-dom';

@connect(
  state => ({
    result: state.auth.result
  }),
  {
    changePassword
  }
)
class ChangePassword extends React.Component<any, any> {
  state = {
    focusedOldPassword: null,
    focusedNewPassword: null
  };

  handleSubmit = (event, errors, { new_password, old_password }) => {
    console.log(`change password ${old_password} -> ${new_password}`);
    const data = {
      new_password,
      old_password
    };
    this.props.changePassword(data);
  };

  render() {
    const { result } = this.props;
    return (
      <>
        { result && <Redirect to={'/auth/logout'} />}
        <SimpleHeader name="Home" parentName="Dashboards" />
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Col lg="5" md="7">
              <Card className="bg-secondary border-0 mb-0">
                <CardBody className="px-lg-5 py-lg-5">
                  <div className="text-center text-muted mb-4">
                    <small>Change password</small>
                  </div>
                  <AvForm role="form" onSubmit={this.handleSubmit}>
                    <FormGroup
                      className={classnames({
                        focused: this.state.focusedNewPassword
                      })}
                    >
                      <InputGroup className="input-group-merge input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-lock-circle-open" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <AvField
                          name="old_password"
                          type="password"
                          className="login-input"
                          placeholder="Old Password"
                          validate={{
                            required: { value: true, errorMessage: "Your password is required." },
                            minLength: { value: 6, errorMessage: "Your password is required to be at least 6 characters." },
                            maxLength: { value: 50, errorMessage: "Your password cannot be longer than 50 characters." }
                          }}
                          onFocus={() => this.setState({ focusedOldPassword: true })}
                          onBlur={() => this.setState({ focusedOldPassword: false })}
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup
                      className={classnames({
                        focused: this.state.focusedNewPassword
                      })}
                    >
                      <InputGroup className="input-group-merge input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-lock-circle-open" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <AvField
                          name="new_password"
                          type="password"
                          className="login-input"
                          placeholder="New Password"
                          validate={{
                            required: { value: true, errorMessage: "Your password is required." },
                            minLength: { value: 6, errorMessage: "Your password is required to be at least 6 characters." },
                            maxLength: { value: 50, errorMessage: "Your password cannot be longer than 50 characters." }
                          }}
                          onFocus={() => this.setState({ focusedNewPassword: true })}
                          onBlur={() => this.setState({ focusedNewPassword: false })}
                        />
                      </InputGroup>
                    </FormGroup>
                    <div className="text-center">
                      <Button className="my-4" color="info" type="submit">
                        Change password
                      </Button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default ChangePassword;
